export default "/_next/static/images/product-apps-5489f2c071573789198e3e969caf92aa.svg";